<template>
  <div v-if="isError">
    <p>Ошибка в ответа сервера, попробуйте обновить страницу.</p>
  </div>
  <div v-else-if="isLoading">
    <!-- placeholder -->
    <div class="mt-1 mb-4" aria-hidden="true">
      <div class="row py-2 placeholder-glow">
        <div class="placeholder col-5 py-3 my-1 me-1"></div>
        <div class="placeholder col-6 py-3 my-1 me-1"></div>
        <div class="placeholder col-4 py-3 my-1 me-1"></div>
        <div class="placeholder col-3 py-3 my-1 me-1"></div>
        <div class="placeholder col-4 py-3 my-1 me-1"></div>
        <div class="placeholder col-5 py-3 my-1 me-1"></div>
        <div class="placeholder col-6 py-3 my-1 me-1"></div>
      </div>
    </div>
  </div>
  <div v-else-if="isCreated">
    <template v-for="(value, index) in result.created">
      <h6 v-if="index == 0" :key="value">{{ value }}</h6>
      <p v-if="index != 0" :key="value">{{ value }}</p>
    </template>
  </div>
  <!-- нет логина -->
  <order-forms-nologin
    v-else-if="!isCreated && isLogged == false"
    :values="values"
    :csrf="csrf"
    :links="links"
    :position="position" />
  <!-- есть логин -->
  <div v-else-if="!isCreated && isLogged == true" class="card card-body mb-4">
    <order-forms-withlogin :url="url" :values="values" :csrf="csrf" @make-order="makeOrder($event)" />
  </div>
</template>

<script>
import axios from 'axios';

import orderFormsWithlogin from './forms/order-forms-withlogin.vue';
import orderFormsNologin from './forms/order-forms-nologin.vue';

export default {
  props: {
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: 'page',
    },
    links: {
      type: Object,
      default: () => {},
    },
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: function () {
    return {
      isLoading: false,
      isError: false,
      isCreated: false,
      isLogged: null,
      // загружаемые данные
      values: {
        email: '',
        fullname: '',
        phone: '',
        mobilephone: '',
        address: '',
        tklist: {},
      },
      url: {
        logout: '',
        profile: '',
      },
      // разное
      modal: {
        buttons: [
          {
            type: 'dismiss',
            text: 'Закрыть',
            class: 'btn btn-primary',
          },
        ],
      },
      // что в отправку
      formData: null,
      // результат
      result: {
        created: [],
      },
    };
  },
  components: {
    orderFormsWithlogin,
    orderFormsNologin,
  },
  methods: {
    makeOrder: function (ev) {
      if (Object.keys(this.order).length == 0) {
        this.$bs5utils.Snack.show(
          'warning',
          'Невозможно создать заказ, так как в заказе нет товаров.<br />Добавьте товары в заказ на странице корзины.',
          this.$store.getters.delay.warning
        );
        return false;
      }

      let client = {
        email: ev.email,
        fullname: ev.fullname,
        phone: ev.phone,
        mobilephone: ev.mobilephone,
        address: ev.address,
        // coordinates: ev.coordinates,
        deliverytype: ev.deliverytype,
        tk: ev.tk,
        comment: ev.comment,
      };

      // что в отправку
      this.formData = new FormData();

      this.appendFormdata(this.csrf, '_token');
      this.appendFormdata(client, 'client');
      this.appendFormdata(this.order, 'order');

      let processing = this.$bs5utils.Modal.show({
        type: 'info',
        title: `Ожидайте`,
        content: `<p class="text-center">Создание заказа, подождите, пожалуйста...</p>`,
        buttons: [],
        centered: true,
        dismissible: false,
        backdrop: 'static',
        keyboard: false,
        focus: true,
      });

      axios
        .post(`${this.$store.getters.urlorder}/process`, this.formData)
        .then((res) => {
          if (processing !== null) {
            processing.hide();
          }

          if (res.data.status) {
            // ok
            this.result.created = res.data.message;
            this.isCreated = true;

            // по одному
            // убираем из заказа и корзины то, что было заказано
            //Object.keys(this.order).forEach((index) => {
            //this.$emit('remove', index)
            //})

            // списком
            // убираем из заказа и корзины то, что было заказано
            this.$emit('removeitems', Object.keys(this.order));

            // жмём в яндекс
            if (window.location.host == 'www.smtauto.ru') {
              // eslint-disable-next-line
              // !!! error! check!
              //ym(18965677, 'reachGoal', 'order_created');
              // товары для выгрузки
              //console.log(this.response.export)
            }

            this.$bs5utils.Modal.show({
              type: 'success',
              title: `Успешно`,
              content: res.data.message.map((el) => `<p>${el}</p>`).join(''),
              buttons: this.modal.buttons,
              centered: true,
              dismissible: true,
              backdrop: 'static',
              keyboard: true,
              focus: true,
            });
          } else {
            // не ok

            // перечитать список заказа
            this.$root.$emit('reload-order', {});

            this.$bs5utils.Modal.show({
              type: 'warning',
              title: `Не удалось`,
              content: res.data.message,
              buttons: this.modal.buttons,
              centered: true,
              dismissible: true,
              backdrop: 'static',
              keyboard: true,
              focus: true,
            });
          }
        })
        .catch((err) => {
          this.$bs5utils.Modal.show({
            type: 'warning',
            title: `Не удалось`,
            content: `При оформлении заказа произошла ошибка на сервере. Попробуйте обновить страницу и попробовать снова. <br /><span class="text-muted">${err}</span>`,
            buttons: this.modal.buttons,
            centered: true,
            dismissible: true,
            backdrop: 'static',
            keyboard: true,
            focus: true,
          });
          console.error(err);
        });
    },
    // https://stackoverflow.com/questions/22783108/convert-js-object-to-form-data
    appendFormdata: function (data, name) {
      name = name || '';
      if (typeof data === 'object') {
        Object.keys(data).forEach((index) => {
          if (name == '') {
            this.appendFormdata(data[index], index);
          } else {
            this.appendFormdata(data[index], name + '[' + index + ']');
          }
        });
      } else {
        this.formData.append(name, data);
      }
    },
    getFormsValues: function () {
      return new Promise((resolve, reject) => {
        // проверить логин и загрузить данные формы
        axios
          .get(`${this.$store.getters.urlorder}/form`)
          .then((res) => {
            this.isLogged = res.data.logged;
            this.values = res.data.values;
            this.url = res.data.url;

            resolve('Форма загружена.');
            return;
          })
          .catch((err) => {
            this.isError = true;

            console.error(err);
            this.$bs5utils.Snack.show('danger', err, this.$store.getters.delay.error);

            reject(new Error(err));
            return;
          });
      });
    },
  },
  created() {
    this.isLoading = true;
  },
  mounted() {
    this.getFormsValues().finally(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style lang="scss">
// говна-пирога!!!
.dadata-input {
  border-radius: 5px;
  padding: 10px 15px;
  border: 1px solid rgba(29, 29, 27, 0.3);
  transition: all 0.2s ease;
}

.suggestions {
  &-nowrap {
    white-space: nowrap;
  }

  &-input {
    -ms-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;

    &::-ms-clear {
      display: none;
    }
  }

  &-wrapper {
    position: relative;
    margin: 0;
    padding: 0;
    vertical-align: top;
    -webkit-text-size-adjust: 100%;
  }

  &-addon {
    display: none;
    opacity: 0;
    position: absolute;

    &[data-addon-type='spinner'] {
      background: rgba(255, 255, 255, 0.75)
        url(data:image/gif;base64,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)
        50% 50% no-repeat;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
    }

    &[data-addon-type='clear'] {
      background: transparent
        url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTAwJyBoZWlnaHQ9JzEwMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48Zz48cGF0aCBkPSdtMjAsMjBtMTAsMGwyMCwyMGwyMCwtMjBsMTAsMTBsLTIwLDIwbDIwLDIwbC0xMCwxMGwtMjAsLTIwbC0yMCwyMGwtMTAsLTEwbDIwLC0yMGwtMjAsLTIwbDEwLC0xMCcgZmlsbD0nIzk5OScvPjwvZz48L3N2Zz4=)
        50% 50% no-repeat;
      background-size: contain;
      cursor: pointer;
      opacity: 0.8;
    }

    &[data-addon-type='clear']:hover {
      opacity: 1;
    }
  }

  &-suggestions {
    background: #fff;
    border: 1px solid #999;
    -ms-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: default;
    z-index: 9999;
    -webkit-text-size-adjust: 100%;

    & strong {
      font-weight: 400;
      color: #39f;
    }

    &.suggestions-mobile {
      border-style: none;

      .suggestions-suggestion {
        border-bottom: 1px solid #ddd;
      }
    }
  }

  &-suggestion {
    padding: 4px 4px;
    overflow: hidden;

    &:hover {
      background: #f7f7f7;
    }
  }

  &-selected {
    background: #f0f0f0;

    &:hover {
      background: #f0f0f0;
    }
  }

  &-hint {
    padding: 4px 4px;
    white-space: nowrap;
    overflow: hidden;
    color: #777;
    font-size: 85%;
    line-height: 20px;
  }

  &-constraints {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    white-space: nowrap !important;

    &:empty {
      display: none !important;
    }

    li {
      background: #f8f8f8;
      border: 1px solid #ccc;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      cursor: default;
      display: inline-block;
      margin: 0 4px 0 0;
      padding: 0 0.5em;

      .suggestions-remove {
        height: 1em;
        width: 1em;
        display: inline-block;
        margin: 0 0 0 0.25em;
        background: transparent
          url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTAwJyBoZWlnaHQ9JzEwMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48Zz48cGF0aCBkPSdtMjAsMjBtMTAsMGwyMCwyMGwyMCwtMjBsMTAsMTBsLTIwLDIwbDIwLDIwbC0xMCwxMGwtMjAsLTIwbC0yMCwyMGwtMTAsLTEwbDIwLC0yMGwtMjAsLTIwbDEwLC0xMCcgZmlsbD0nIzk5OScvPjwvZz48L3N2Zz4=)
          50% 50% no-repeat;
        background-size: contain;
        cursor: pointer;
        opacity: 0.8;

        &:hover {
          opacity: 1;
        }
      }

      span {
        vertical-align: middle;
      }
    }
  }

  &-subtext {
    color: #777;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &_inline {
      display: inline-block;
      min-width: 6em;
      vertical-align: bottom;
      margin: 0 0.5em 0 0;
    }

    &-delimiter {
      display: inline-block;
      width: 2px;
    }

    &_label {
      margin: 0 0 0 0.25em;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      padding: 0 3px;
      background: #f5f5f5;
      font-size: 85%;
    }
  }

  &-value {
    &[data-suggestion-status='LIQUIDATED'] {
      position: relative;

      &:after {
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        border-top: 1px solid rgba(0, 0, 0, 0.4);
        content: '';
      }
    }
  }

  &-promo {
    font-size: 85%;
    display: none;
    color: #777;
    padding: 4px;
    text-align: center;

    a {
      color: #777;
      display: block;
      filter: grayscale(100%);
      line-height: 20px;
      text-decoration: none;

      &:hover {
        filter: grayscale(0);
      }
    }

    svg {
      height: 20px;
      vertical-align: bottom;
    }

    &-desktop {
      position: absolute;
      top: 0;
      right: 0;
      text-align: left;
    }
  }
}
</style>
